import { generatePerspectiveFaces } from './perspectiveDataGenerator';

export interface PerspectiveFace {
    id: 'products' | 'people' | 'organizations' | 'competences' | 'family' | 'community';
    title: string;
    subtitle: string;
    color: string;
    description: string;
    tiles: ExperienceTile[];
    isPrivate?: boolean;
}

export interface ExperienceTile {
    id: string;
    title: string;
    subtitle: string;
    period: string;
    icon: string;
    summary: string;
    imageUrl?: string | { src: string };
    type: 'text' | 'image';
    detailedView?: {
        description: string;
        achievements: string[];
        skills: string[];
        connections: string[];
    };
    span?: number; // Manual override for grid span
}

// Generate perspective faces from career data
export const perspectiveFaces: PerspectiveFace[] = generatePerspectiveFaces();
